<template>
    <div class="h5_container">
       <div class="h5_container_main" v-if="!isShow">
           <div class="h5_container_main_icon" @click="$router.push('/index')">
              <img src="@/assets/index/Group 2.png">
           </div>
            <div class="h5_container_main_right">
              <div class="h5_container_main_right_search" @click="handleClick">
                  <img src="@/assets/index/search.png">
              </div>
              <div class="h5_container_main_right_menu" @click="handlePush" v-if="!isClose">
                  <img src="@/assets/index/menu.png">
              </div>
              <div class="h5_container_main_right_menu" @click="handle" v-else>
                  <img src="@/assets/index/close.png">
              </div>
           </div>
       </div>
       <!-- 搜索样式 -->
       <div class="h5_container_searchStyle" v-else>
           <div class="h5_container_searchStyle_input">
                <img src="@/assets/index/search.png" class="h5_container_searchStyle_input_image">
               <input type="text" placeholder="输入关键词搜索内容" v-model="input" @keyup.13 = "handleKeyUp">
           </div>
           <div @click="handleClose">取消</div>
       </div>
      
     
    </div>
</template>

<script>
export default {
  data() {
    return {
      input: "",
      isShow: false,
      isClose:false,
      
    };
  },
  watch: {
    $route: {
      handler(val) {
       console.log("路由",val);
       if(val.fullPath!='/menu'){
           this.isClose=false;
       }else{
            this.isClose=true;
       }
    }
  }
  },
  
  methods: {
    handleClick() {
      this.isShow = true;
    },
    handleClose() {
        this.input=''
      this.isShow = false;
    },
    handlePush(){
        this.isClose=true;
        this.$router.push('/menu')
    },
    handle(){
        
        this.isClose=false;
         this.$router.push('/index')
    },
    handleKeyUp(){
         this.$router.push({ path: "/sreach", query: { value: this.input } });
        
    }
  }
};
</script>


<style lang="scss" scoped>
.h5_container {
  min-width: 750px;
  height: 300px;
  background: #2d2e38;
  &_main {
    display: flex;
    justify-content: space-between;
    height: 100%;
    &_icon {
      min-width: 136px;
      height: 100%;
      img {
        // object-fit: scale-down	;
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    &_right {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 32px 64px 32px 0;
      box-sizing: border-box;
      
      &_search,
      &_menu {
        width: 150px;
        height: 150px;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      &_search {
        margin-right: 64px;
         width: 120px;
        height: 120px;
      }
    }
  }
  &_searchStyle {
    display: flex;
    justify-content: space-between;
    height: 100%;
    padding: 64px 64px;
    box-sizing: border-box;
    &_input {
      flex: 1;
      height: 100%;
      position: relative;
      input {
        width: 100%;
        height: 100%;
        outline: none;
        // background: #ffffff;
        border-radius: 4px;
        border: none;
        // opacity: 0.19;
        background: rgba(83, 83, 83, 0.5);
        padding: 0 0 0 180px;
        box-sizing: border-box;
        color: #fff;
      }
      &_image {
        width: 90px;
        height: 90px;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -3%;
        margin-left: 4%;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
    div:nth-child(2) {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 400px;
        font-size:84px;
      color: #2e54eb;
    }
  }

}

input::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.568);
  font-size:64px;
}
input:-moz-placeholder {
  color: rgba(255, 255, 255, 0.568);
  font-size:64px;
}
input::-moz-placeholder {
  color: rgba(255, 255, 255, 0.568);
  font-size:64px;
}
</style>





// WEBPACK FOOTER //
// src/components/com-h5-header.vue